var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCollapseGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.2812 11.7812L21.0312 16H23.75C24.1562 16 24.5 16.3438 24.5 16.75C24.5 17.1875 24.1562 17.5 23.75 17.5H19.25C18.8125 17.5 18.5 17.1875 18.5 16.75V12.25C18.5 11.8438 18.8125 11.5 19.25 11.5C19.6562 11.5 20 11.8438 20 12.25V14.9688L24.2188 10.75C24.5 10.4375 24.9688 10.4375 25.2812 10.75C25.5625 11.0312 25.5625 11.5 25.2812 11.7812ZM10.7188 24.2188L14.9375 20H12.25C11.8125 20 11.5 19.6875 11.5 19.25C11.5 18.8438 11.8125 18.5 12.25 18.5H16.7188C17.1562 18.5 17.4688 18.8438 17.4688 19.25V23.75C17.4688 24.1875 17.1562 24.5 16.7188 24.5C16.3125 24.5 15.9688 24.1875 15.9688 23.75V21.0625L11.75 25.2812C11.4688 25.5938 11 25.5938 10.7188 25.2812C10.4062 25 10.4062 24.5312 10.7188 24.2188Z",
    fill: "#808B9A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapseGray);
export default __webpack_public_path__ + "static/media/collapse-gray.e5733c53c1befe19a87a8a7a854a2f8f.svg";
export { ForwardRef as ReactComponent };